var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4928 3.49756V4.08048H11.6586V3.49756C11.6586 1.56865 10.09 0 8.16105 0H7.57812V1.16585H8.16105C9.44699 1.16585 10.4928 2.21162 10.4928 3.49756Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49788 10.4931V9.91016H2.33203V10.4931C2.33203 12.422 3.90069 13.9906 5.82959 13.9906H6.41252V12.8248H5.82959C4.54365 12.8248 3.49788 11.779 3.49788 10.4931Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24634 0H1.16585C0.521719 0 0 0.521719 0 1.16585V7.57804C0 8.22218 0.521719 8.7439 1.16585 8.7439H5.24634C5.89047 8.7439 6.41219 8.22218 6.41219 7.57804V1.16585C6.41219 0.521719 5.89047 0 5.24634 0ZM5.24634 6.99512H1.16585V1.74878H5.24634V6.99512Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8245 5.24609H8.74398C8.09984 5.24609 7.57812 5.76781 7.57812 6.41195V12.8241C7.57812 13.4683 8.09984 13.99 8.74398 13.99H12.8245C13.4686 13.99 13.9903 13.4683 13.9903 12.8241V6.41195C13.9903 5.76781 13.4686 5.24609 12.8245 5.24609ZM12.8245 12.2412H8.74398V6.99487H12.8245V12.2412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.45b0d783f710b0763dd228c52840fc83.svg";
export { ForwardRef as ReactComponent };